import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { onAuthStateChanged, updateProfile } from "firebase/auth";
import SettingsModal from "./SettingsModal";

const SettingsInfo = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                setName(user.displayName || "");
                setEmail(user.email || "");

                try {
                    const userRef = doc(db, "users", user.uid);
                    const docSnap = await getDoc(userRef);
                    if (docSnap.exists()) {
                        const data = docSnap.data();
                        setPhone(data.phone || "");
                    }
                } catch (err) {
                    setMessage("Error fetching user data: " + err.message);
                }

                setLoading(false);
            } else {
                setMessage("User not authenticated.");
                setLoading(false);
            }
        });

        return () => unsubscribe();
    }, []);

    useEffect(() => {
        if (message) {
            const timeout = setTimeout(() => {
                setMessage("");
            }, 3000);
            return () => clearTimeout(timeout);
        }
    }, [message]);

    const handleUpdate = async (e) => {
        e.preventDefault();
        setMessage("");

        const user = auth.currentUser;
        if (!user) {
            setMessage("User not authenticated.");
            return;
        }

        try {
            await updateProfile(user, { displayName: name });

            const userRef = doc(db, "users", user.uid);
            await setDoc(userRef, { name, email, phone }, { merge: true });

            setMessage("✅ Profile updated successfully!");
        } catch (err) {
            setMessage(`❌ Error: ${err.message}`);
        }
    };

    return (
        <section className="nav-body-bg btm-rad pb-5 min-vh-100">
            <div className="d-flex justify-content-center align-items-center pt-5">
                <div style={{ width: "100%", maxWidth: "400px" }}>
                    <h4 className="text-center text-white text-h1 mb-2">Personal Information</h4>

                    {message && (
                        <div className={`alert ${message.startsWith("❌") ? "alert-danger" : "alert-success"}`}>
                            {message}
                        </div>
                    )}

                    <form onSubmit={handleUpdate}>
                        <div className="mb-2">
                            <label className="form-label fw-semibold">Name</label>
                            <input
                                type="text"
                                className="form-control rounded-3"
                                placeholder="Enter your name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                        </div>

                        <div className="mb-2">
                            <label className="form-label fw-semibold">Email</label>
                            <input
                                type="email"
                                className="form-control rounded-3"
                                placeholder="Enter your email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                disabled
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label fw-semibold">Phone number</label>
                            <input
                                type="tel"
                                className="form-control rounded-3"
                                placeholder="Enter your phone number"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                            />
                        </div>

                        <div className="d-grid mb-4">
                            <button type="submit" className="btn btn-primary py-1">
                                Update
                            </button>
                        </div>

                        <div className="d-grid">
                            <button
                                type="button"
                                className="btn text-white py-1"
                                style={{ backgroundColor: "#FB8C00" }}
                                data-bs-toggle="modal"
                                data-bs-target="#changePasswordModal"
                            >
                                Change Password
                            </button>
                        </div>
                    </form>
                    <SettingsModal />
                </div>
            </div>
        </section>
    );
};

export default SettingsInfo;
